import { __awaiter } from 'tslib';
import { IMRtcApi, IMRtcStream, IMRtcClient } from '../abstract/IMRtcApi.js';
import VRTC from '@byted/byte-rtc';

class BrowserRtcApi extends IMRtcApi {
    checkSystemRequirements() {
        return VRTC.checkSystemRequirements();
    }
    setLogLevel(level) {
        return VRTC.Logger.setLogLevel(level);
    }
    createClient(rtcAppId) {
        return new BrowserRtcClient(this.ctx, rtcAppId);
    }
    getDevices() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise(resolve => {
                VRTC.getDevices(result => {
                    resolve(result);
                }, () => {
                    resolve([]);
                });
            });
        });
    }
    createStream(options) {
        const internalStream = VRTC.createStream(options);
        return new BrowserRtcStream(this.ctx, internalStream);
    }
}
class BrowserRtcStream extends IMRtcStream {
    constructor(ctx, stream) {
        super(ctx);
        this.internalStream = stream;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                this.internalStream.init(() => {
                    resolve();
                }, (err) => {
                    reject(err);
                });
            });
        });
    }
    close() {
        return this.internalStream.close();
    }
    stop() {
        return this.internalStream.stop();
    }
    setVideoBitRate(rate) {
        return this.internalStream.setVideoBitRate(rate);
    }
    setVideoProfile(profile) {
        return this.internalStream.setVideoProfile(profile);
    }
    setVideoEncoderConfiguration(encoderConfig) {
        return this.internalStream.setVideoEncoderConfiguration(encoderConfig);
    }
    play(domID, option) {
        return new Promise((resolve, reject) => {
            this.internalStream.play(domID, option, err => {
                reject(err);
            });
            resolve();
        });
    }
    hasVideo() {
        return this.internalStream.hasVideo();
    }
    muteVideo() {
        return this.internalStream.muteVideo();
    }
    unmuteVideo() {
        return this.internalStream.unmuteVideo();
    }
    hasAudio() {
        return this.internalStream.hasAudio();
    }
    muteAudio() {
        return this.internalStream.muteAudio();
    }
    unmuteAudio() {
        return this.internalStream.unmuteAudio();
    }
    switchCamera() {
        return 'front';
    }
}
class BrowserRtcClient extends IMRtcClient {
    constructor(ctx, rtcAppId) {
        super(ctx);
        this.internalClient = VRTC.createClient('rtc');
        this.rtcAppId = rtcAppId;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                this.internalClient.init(this.rtcAppId, () => {
                    resolve();
                }, (err) => {
                    reject(err);
                });
            });
        });
    }
    publish(stream, option) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                var _a;
                this.internalClient.publish((_a = stream.internalStream) !== null && _a !== void 0 ? _a : stream, {}, err => {
                    reject(err);
                }).then(() => {
                    resolve();
                }).catch(err => {
                    reject(err);
                });
            });
        });
    }
    unpublish(stream) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                var _a;
                this.internalClient.unpublish((_a = stream.internalStream) !== null && _a !== void 0 ? _a : stream, err => {
                    reject(err);
                }).then(() => {
                    resolve();
                }).catch(err => {
                    reject(err);
                });
            });
        });
    }
    on(event, handler) {
        return this.internalClient.on(event, handler);
    }
    off(event, handler) {
        return this.internalClient.off(event, handler);
    }
    subscribe(stream, option) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                var _a;
                this.internalClient.subscribe((_a = stream.internalStream) !== null && _a !== void 0 ? _a : stream, option, err => {
                    reject(err);
                }).then(() => {
                    resolve();
                }).catch(err => {
                    reject(err);
                });
            });
        });
    }
    join(token, channelId, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                this.internalClient.join(token, channelId, userId, () => {
                    resolve();
                }, err => {
                    reject(err);
                });
            });
        });
    }
    leave() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                this.internalClient.leave(() => {
                    resolve();
                }, err => {
                    reject(err);
                }).then(() => {
                    resolve();
                }).catch(err => {
                    reject(err);
                });
            });
        });
    }
    getLocalVideoStats() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise(resolve => {
                this.internalClient.getLocalVideoStats((result) => {
                    resolve(result);
                });
            });
        });
    }
    getLocalAudioStats() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise(resolve => {
                this.internalClient.getLocalAudioStats(result => {
                    resolve(result);
                });
            });
        });
    }
    getRemoteVideoStats() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise(resolve => {
                this.internalClient.getRemoteVideoStats(result => {
                    resolve(result);
                });
            });
        });
    }
    getRemoteAudioStats() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise(resolve => {
                this.internalClient.getRemoteAudioStats(result => {
                    resolve(result);
                });
            });
        });
    }
}

export { BrowserRtcApi, BrowserRtcClient, BrowserRtcStream };
//# sourceMappingURL=BrowserRtcApi.js.map
